import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";

const TermAndContions = () => {
  return (
    <>
      <Meta title={"Terms And Conditions"} />
      <BreadCrumb title="Terms And Conditions" />
      <Container className="policy-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12 bg-white">
          <div className="policy px-5">
  <h1>Terms And Conditions</h1>
  <div>
    <b>1. Introduction</b>
    <ul>
      <li>
        <b>1.1</b> This website (www.thebestsellersshop.com), related mobile-sites, and software applications (hereinafter referred to as the ‘Website’) is owned and operated by The Best Sellers Shop Limited (hereinafter referred to as ‘us’, ‘we’, ‘our’, ‘The Best Sellers Shop’, ‘the Supplier’), a retailer of office furniture products.
      </li>
      <li>
        <b>1.2</b> The disclaimers, policies, and terms and conditions on this page (hereinafter referred to as ‘Terms’ and/or ‘Conditions’) shall govern the order, sale, and/or delivery of goods or services from The Best Sellers Shop as well as the use of this Website by any customer or person (hereinafter referred to as ‘you’, ‘your’, ‘user’, ‘customer’).
      </li>
      <li>
        <b>1.3</b> Any personal information or data collected when using this Website, whether through communication, purchase invoicing, or customer inquiry (as well as in-store transactions), shall be utilized for customer service, internal market research, or direct marketing. This information shall not be shared with third parties except as necessary for customer service and delivery. For more information on the use of personal data, please refer to our ‘User Data Policy’ available on our Website.
      </li>
      <li>
        <b>1.4</b> The Terms apply to all users/customers/visitors of The Best Sellers Shop website or any associated store (whether owned by The Best Sellers Shop or a third-party agent or franchisee).
      </li>
      <li>
        <b>1.5</b> By accessing and using this Website, you accept and agree to be bound by and comply with the Terms and Conditions. If you do not agree to these Terms and Conditions, you are not authorized to access our Website, use any of our services, or place an order on the Website.
      </li>
    </ul>
  </div>

  <div>
    <b>2. Waiver</b>
    <ul>
      <li><b>2.1 </b>
      If the website (The Best Sellers Shop) does not enforce or exercise any of its rights or provisions under the terms and conditions at a given time, this does not mean it has permanently given up or "waived" that right. The website can still enforce it later. Moreover, any waiver (giving up the right) is only valid if it's communicated in writing.
      </li>
    </ul>
  </div>
  <div>
  <b>3. Severability</b>
  <ul>
    <li><b>3.1</b> If any part of the terms and conditions (like a specific rule or provision) is found to be invalid or unenforceable by a legal authority, that specific part will be removed ("severed") without affecting the validity or enforceability of the rest of the terms. The rest of the agreement will still be legally binding and enforceable to the fullest extent allowed by law.</li>
  </ul>
</div>

<div>
  <b>4. Variation</b>
  <ul>
    <li><b>4.1</b> The Best Sellers Shop reserves the right, at its sole discretion, to modify or update any of these terms, conditions, or policies without prior notice. It is the user’s responsibility to review the terms regularly and ensure they are in agreement with any changes that may occur.</li>
    <li><b>4.2</b> By continuing to use the website after any changes have been made, you are accepting those changes. If you do not agree with the updated terms, you should refrain from using the website or conducting any transactions with us, whether online or in-store.</li>
  </ul>
</div>


<div>
  <b>5. Errors, Omissions, and Product Descriptions</b>
  <ul>
    <li><b>5.1</b> While we make every reasonable effort to provide accurate information about our products (including pricing, availability, features, and descriptions), we do not accept liability for any loss or claim resulting from errors or inaccuracies. We reserve the right to correct any mistakes, inaccuracies, or omissions and to update information at any time without prior notice, including after an order has been placed. In cases where significant corrections are made, we will make reasonable efforts to notify affected customers.</li>
    <li><b>5.2</b> Product descriptions on this website are provided for marketing purposes in a simple, easy-to-understand format. They do not represent exhaustive technical specifications, and some terms may be used in a general sense or for specific marketing purposes.</li>
  </ul>
</div>


<div>
  <b>6. Pricing & Stock</b>
  <ul>
    <li><b>6.1</b> All prices listed on our website include VAT at a rate of 16%.</li>
    <li><b>6.2</b> The prices displayed are applicable to in-stock items only. If a product is out of stock, and you place an order or make an inquiry before the price, specification, or promotion is updated, we will inform you of any changes before processing the order. If you do not accept the updated terms, we reserve the right to cancel the order or part of it.</li>
    <li><b>6.3</b> While most products on this website are in stock, there may be instances where items are temporarily unavailable or require a waiting period due to custom production.</li>
  </ul>
</div>

<div>
  <b>7. Images</b>
  <ul>
    <li><b>7.1</b> All images, including product photos, logos, banners, audio or video clips, trademarks, trade names, layouts, icons, and text used on this website are the property of The Best Sellers Shop Limited or the brands, partners, suppliers, or service providers we represent. These are protected by law. Any unauthorized use, reproduction, or distribution is strictly prohibited and may only be done with the express written permission of The Best Sellers Shop Limited.</li>
  </ul>
</div>


<div>
  <b>8. Applicable Law</b>
  <ul>
    <li><b>8.1</b> By using any services provided by The Best Sellers Shop, you agree that all agreements, terms, and legal documents shall be governed by the laws of [Your Country], without regard to conflict of laws principles.</li>
  </ul>
</div>


<div>
  <b>9. Company Information & Contact Details</b>
  <ul>
    <li>
      <b>9.1</b> This website is owned and operated by The Best Sellers Shop Ltd. Contact details: Tel. 2541 13 886 482. Email: info@thebestsellersshop.co.ke
     </li>
  </ul>
</div>

</div>


          </div>
        </div>
      </Container>
    </>
  );
};

export default TermAndContions;
